import React, { Component } from "react"
import Modal from "react-bootstrap/lib/Modal"
import { appStrings } from "../../common/strings/app_strings"
import { TUTORIAL_URL } from "../../common/constants/app_consts"
const {
    welcome,
    hasInvited,
    onShoutbase,
    skip,
    message,
} = appStrings.acceptInviteModal

// todo: uncomment when Shoutbase tutorial is ready
export class AcceptInviteModal extends Component {
    render() {
        const { currentInvite, cancel } = this.props
        if (!currentInvite) {
            return
        }
        const { inviterFullName, inviterEmail, teamName } = currentInvite
        const inviteMessage = `${inviterFullName || inviterEmail} ${hasInvited}
        ${currentInvite && teamName} ${onShoutbase}`
        return (
            <Modal
                dialogClassName="team-invite-modal"
                className="modal-v2"
                show={!!currentInvite}
                animation={false}
            >
                <Modal.Body
                    id="modal-body"
                    style={{ height: window.innerHeight }}
                >
                    <h2>{welcome}</h2>
                    <p>{inviteMessage}</p>
                    {message}
                    <div className="form-actions">
                        <a
                            className="a-button"
                            href={TUTORIAL_URL}
                            target="_blank"
                        >
                            <button
                                id="submit"
                                className="btn btn-primary btn-block btn-lg"
                                tabIndex="5"
                                onClick={cancel}
                            >
                                Continue to tutorial
                            </button>
                        </a>
                    </div>
                    <div className="row">
                        <p
                            id="skip"
                            className="text-center note-text"
                            onClick={cancel}
                        >
                            {skip}
                        </p>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modals/accept_invite_modal.jsx